import script from "./ChatList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatList.vue?vue&type=script&setup=true&lang=ts"

import "./ChatList.vue?vue&type=style&index=0&id=2a5cf104&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5cf104"]])

export default __exports__